import React from 'react';
import { Alert, Typography, Space, Card } from 'antd';
import { NotificationOutlined, WarningOutlined } from '@ant-design/icons';

const { Paragraph, Title, Text } = Typography;

/**
 * Component for displaying global notification messages to all users
 */
const GlobalNotifications = () => {
  // These are your important messages that need to be shown
  const notifications = [
    {
      id: 'policy-warning',
      type: 'warning',
      title: '账号风控提醒',
      icon: <WarningOutlined />,
      message: '最近风控严格，建议使用你们的号码多多申请一些其他平台的验证码，比如tiktok store，temu，amazon，有关电商类的是PingMe的白名单。如果只是单一的whatsapp解码，可能会被人工审核，然后封号。我这边无法解除。如果有其他平台的验证码，到时候还可以说，这些whatsapp验证是旧号主申请的和你们没关系。'
    },
    {
      id: 'subscription-policy',
      type: 'info',
      title: '订阅政策更新',
      icon: <NotificationOutlined />,
      message: '封控严格，现在创建账号，会直接根据你账号里的号码数量先扣款。就相当于把你们这些号码都直接订阅上了。比如pingme账号里有30个号码，再添加pingme账号时，会直接自动订阅这全部30个号码。并且扣款，如果余额不足会导致你的账号无法使用。请联系管理员充值。'
    }
  ];

  return (
    <Card bordered={false} className="global-notifications-card" style={{ marginBottom: 16 }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        {notifications.map((notification) => (
          <Alert
            key={notification.id}
            message={notification.title}
            description={
              <Paragraph style={{ whiteSpace: 'pre-line', margin: 0 }}>
                {notification.message}
              </Paragraph>
            }
            type={notification.type}
            showIcon
            icon={notification.icon}
          />
        ))}
      </Space>
    </Card>
  );
};

export default GlobalNotifications; 